module.exports = __webpack_public_path__ + "img/pic1-3.bac5e158.png";